import { render, staticRenderFns } from "./staticQuestionSelect.vue?vue&type=template&id=a614074c&scoped=true&"
import script from "./staticQuestionSelect.vue?vue&type=script&lang=js&"
export * from "./staticQuestionSelect.vue?vue&type=script&lang=js&"
import style0 from "./staticQuestionSelect.vue?vue&type=style&index=0&id=a614074c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a614074c",
  null
  
)

export default component.exports